function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M61 1.414l29.699 29.699c16.402 16.402 16.402 42.995 0 59.397-16.402 16.403-42.996 16.403-59.398 0-16.402-16.402-16.402-42.995 0-59.397L61 1.414z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93 88.5v-7.127c0-7.952-7.594-13.705-15.249-11.552L64.249 73.62a12 12 0 01-6.498 0L44.25 69.82C36.594 67.668 29 73.421 29 81.373V88.5",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.266 84.532L45.633 68.9c-8.634-8.634-8.634-22.632 0-31.266v0c8.633-8.634 22.632-8.634 31.266 0v0c8.634 8.634 8.634 22.632 0 31.266L61.266 84.532z",
  stroke: "currentColor",
  fill: "transparent",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.5 60.532c-4.418 4.419-11.582 4.419-16 0",
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgEmblemPeople = function SvgEmblemPeople(props) {
  return React.createElement("svg", _extends({
    width: 122,
    height: 122,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgEmblemPeople;